import axios from "axios";
import { userEndpoint } from "./API_endpoint";
import { Base_URL } from "./Base_URL";

// const token = localStorage.getItem("token");
// Helper function to get token
const getToken = () => localStorage.getItem("token");
// Users
export const getAllUsers = async () => {
  const token = getToken();
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getAllUsers}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (err) {
    return { err };
  }
};

export const searchUsers = async (query) => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.searchUsers(encodeURIComponent(query))}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const approveUser = async (idsOrId) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.approveUser}`,
      {
        ids: Array.isArray(idsOrId) ? idsOrId : [idsOrId],
        is_active: true
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const deleteUserAction = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteUser(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateClubStatusAction = async (id, status) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateClubStatus(id)}`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateUserStatus = async (idsOrId, isActive) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateUserStatus}`,
      {
        ids: Array.isArray(idsOrId) ? idsOrId : [idsOrId],
        is_active: isActive
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

// Admin: create temp user (student) directly
export const createTempUser = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(
      `${Base_URL}${userEndpoint.tempUserSignup}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Admin-only: create user via /user/signupbyadmin
export const adminCreateUser = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(
      `${Base_URL}${userEndpoint.adminCreateUser}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const deleteAllTempUsers = async () => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteAllTempUsers}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Admins
export const getAllAdmins = async () => {
  const token = getToken();
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getAllAdmins}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (err) {
    return { err };
  }
};

export const createAdmin = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(
      `${Base_URL}${userEndpoint.createAdmin}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateAdminProfile = async (id, data) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateAdminProfile(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const deleteAdmin = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteAdmin(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Events
export const createEvent = async (data) => {
  const token = getToken();
  try {
    let res = await axios.post(`${Base_URL}${userEndpoint.createEvent}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateEvent = async (data, id) => {
  const token = getToken();
  try {
    let res = await axios.put(
      `${Base_URL}${userEndpoint.updateEvent(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getEvent = async (id) => {
  const token = getToken();
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getEvent(id)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (err) {
    return { err };
  }
};

// Facility

export const createFacility = async (data) => {
  const token = getToken();
  try {
    let res = await axios.post(
      `${Base_URL}${userEndpoint.createFacility}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateFacility = async (data, id) => {
  const token = getToken();
  try {
    let res = await axios.put(
      `${Base_URL}${userEndpoint.updateFacility(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getFacility = async (id) => {
  const token = getToken();
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getFacility(id)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (err) {
    return { err };
  }
};

// Facility reservations

export const createFacilityReservations = async (data) => {
  const token = getToken();
  try {
    let res = await axios.post(
      `${Base_URL}${userEndpoint.createFacilityReservations}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateFacilityReservations = async (data, id) => {
  const token = getToken();
  try {
    let res = await axios.put(
      `${Base_URL}${userEndpoint.updateFacilityReservations(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const getFacilityReservation = async (id) => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getFacilityReservation(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};
// Event Registration List

export const getEventRegistrationList = async (id) => {
  try {
    // const tokent = localStorage.getItem("token");
    const token = getToken();
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getEventRegistrationListbyEventid(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const deleteRegistration = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteEventRegistration(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

// student side Events API
export const deleteEventRegistration = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteEventRegistration(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const getEventRegistrationInfo = async (eventId, userId) => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getEventRegistrationInfo(eventId, userId)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    console.log("errr");
    return err;
  }
};

export const addEventRegistration = async (data) => {
  const token = getToken();
  try {
    //console.log( `${Base_URL}${userEndpoint.addEventRegistration}`)
    const token = localStorage.getItem("token");
    const res = await axios.post(
      `${Base_URL}${userEndpoint.addEventRegistration}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const updateEventRegistration = async (data, id) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateEventRegistration(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return err.response.data;
  }
};

// student side Facilities API

export const deleteFacilityRegistration = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteFacilityRegistration(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const getFacilityRegistrationInfo = async (facility_id, user_id) => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getFacilityRegistrationInfo(
        facility_id,
        user_id
      )}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const addFacilityRegistration = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(
      `${Base_URL}${userEndpoint.addFacilityRegistration}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const updateFacilityRegistration = async (data, id) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateFacilityRegistration(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const getBookedSlots = async (facility_id) => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getBookedSlots(facility_id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const assignInventory = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(
      `${Base_URL}${userEndpoint.assignInventory}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const updateAssignInventory = async (data, id) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateAssignInventory(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

export const getInvRegistrationInfo = async (invId, userId) => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getInvRegistrationInfo(invId, userId)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res;
  } catch (err) {
    console.log("errr");
    return err;
  }
};

export const deleteInvRegistration = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteInvRegistration(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (err) {
    return { err };
  }
};

// Clubs
export const addClub = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(`${Base_URL}${userEndpoint.addClub}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Users - Admin profile update
export const updateUserProfile = async (userId, data) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateUserProfile(userId)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getAllClubs = async () => {
  const token = getToken();
  try {
    const config = {};
    if (token) {
      config.headers = { Authorization: `Bearer ${token}` };
    }
    const res = await axios.get(`${Base_URL}${userEndpoint.getAllClubs}`, config);
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const searchClubs = async (name) => {
  const token = getToken();
  try {
    const config = {};
    if (token) {
      config.headers = { Authorization: `Bearer ${token}` };
    }
    const res = await axios.get(
      `${Base_URL}${userEndpoint.searchClubs(encodeURIComponent(name))}`,
      config
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getClubById = async (id) => {
  const token = getToken();
  try {
    const config = {};
    if (token) {
      config.headers = { Authorization: `Bearer ${token}` };
    }
    const res = await axios.get(`${Base_URL}${userEndpoint.getClubById(id)}`, config);
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateClub = async (id, data) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateClub(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const deleteClub = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteClub(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Labs
export const addLab = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(`${Base_URL}${userEndpoint.addLab}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getAllLabs = async () => {
  const token = getToken();
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getAllLabs}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getLabById = async (id) => {
  const token = getToken();
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getLabById(id)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateLab = async (id, data) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateLab(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const deleteLab = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(`${Base_URL}${userEndpoint.deleteLab(id)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Lab Incharge
export const addLabIncharge = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(
      `${Base_URL}${userEndpoint.addLabIncharge}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getAllLabIncharges = async () => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getAllLabIncharges}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getLabInchargeById = async (id) => {
  const token = getToken();
  try {
    const res = await axios.get(
      `${Base_URL}${userEndpoint.getLabInchargeById(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateLabIncharge = async (id, data) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateLabIncharge(id)}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const deleteLabIncharge = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(
      `${Base_URL}${userEndpoint.deleteLabIncharge(id)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateLabInchargePassword = async (id, newPassword) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateLabInchargePassword(id)}`,
      { newPassword },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Inventory Registration Status
export const updateInventoryRegistrationStatus = async (id, status) => {
  const token = getToken();
  try {
    const res = await axios.put(
      `${Base_URL}${userEndpoint.updateInventoryRegistrationStatus(id)}`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return { err };
  }
};

// Blogs
export const getAllBlogs = async () => {
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getAllBlogs}`);
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const getBlogBySlug = async (slug) => {
  try {
    const res = await axios.get(`${Base_URL}${userEndpoint.getBlogBySlug(slug)}`);
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const createBlog = async (data) => {
  const token = getToken();
  try {
    const res = await axios.post(`${Base_URL}${userEndpoint.createBlog}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const updateBlog = async (id, data) => {
  const token = getToken();
  try {
    const res = await axios.put(`${Base_URL}${userEndpoint.updateBlog(id)}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};

export const deleteBlog = async (id) => {
  const token = getToken();
  try {
    const res = await axios.delete(`${Base_URL}${userEndpoint.deleteBlog(id)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return { err };
  }
};
